import { injectable } from 'inversify-props';
import BaseService from '@/services/base-service';
import EngagementScoreModel from '@/models/crm/engagement-score.model';
import { RequestConfig } from '@/interfaces/request-config.interface';
import { ClientTypeEnum } from '@/enums/client-type.enum';

@injectable()
export default class EngagementScoreService extends BaseService {
  async getEngagementScore(
    clientId: string,
    type: ClientTypeEnum,
    index?: string,
  ): Promise<EngagementScoreModel | null> {
    const config: RequestConfig = {
      params: {
        clientId,
        type,
        index: index || undefined,
      },
    };
    return (await this.httpService.get(
      EngagementScoreModel,
      `${this.getApiPath()}/crm/engagement-score`,
      config,
    )) as EngagementScoreModel;
  }
}
